import React from 'react';
import IconBase from './shared/icon-base';
import { jsx as ___EmotionJSX } from "@emotion/core";
export default function UnderlineIcon(props) {
  return ___EmotionJSX(IconBase, props, ___EmotionJSX("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20H18V19H6V20ZM10 4V11.531C10 13.042 10.99 14 12 14C12.99 14 14 13.063 14 11.531V4H17V11.492C17 15.599 14.855 17 12.01 17C9.166 17 7 15.599 7 11.492V4H10Z",
    fill: "currentColor"
  }));
}